module.exports = __webpack_public_path__ + "img/1.e1c8e996.png";